<template>

</template>

<script>
export default {
  name: "Global",
  host: 'http://52.194.210.238:39457'
}
</script>

<style scoped>

</style>